export default __webpack_public_path__ + "static/media/iconListActive.a55e6830.svg";